import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@/lib/auth-context'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import App from './App'
import './index.css'

function startVersionCheckWorker() {
  if (typeof Worker === 'undefined') return
  if (typeof window === 'undefined' || window.location.protocol === 'file:') return
  try {
    const worker = new Worker('/version-check.worker.js')
    worker.onmessage = (ev: MessageEvent) => {
      if (ev.data?.type === 'APP_VERSION_CHANGED') {
        worker.terminate()
        window.location.reload()
      }
    }
    worker.postMessage({ type: 'START', intervalMs: 120_000 })
  } catch (e) {
    console.warn('Version check worker failed:', e)
  }
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // Detect a new service worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          if (!newWorker) return
          newWorker.addEventListener('statechange', () => {
            // "installed" + existing controller === an update (not first install)
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              // Ask the new SW to skip waiting
              newWorker.postMessage({ type: 'SKIP_WAITING' })
            }
          })
        })
        // Reload the page exactly once when the new SW takes control
        let refreshing = false
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return
          refreshing = true
          window.location.reload()
        })
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error)
      })
  })
}

startVersionCheckWorker()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </AuthProvider>
  </StrictMode>,
)
